// eslint-disable-next-line no-restricted-imports -- only place where we allow this import
import styled, {
  type CreateStyled,
  type StyledComponent,
} from '@emotion/styled'
import { type WithTheme as EmotionWithTheme } from '@emotion/react'
import { type ResponsiveValue, system } from 'styled-system'
import { type Property } from 'csstype'

import { Theme } from './theme'

export type WithTheme<P> = EmotionWithTheme<P, Theme>

export interface TransformProps {
  transform?: ResponsiveValue<Property.Transform>
}

export const transform = system({
  transform: true,
})

export default styled as CreateStyled

export { type StyledComponent }
